let credentails = [
    {
        username: "user1@gmail.com",
        password: "pass1",
    },
    {
        username: "user2@gmail.com",
        password: "pass2",
    },
];

export default credentails;
